// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.zyzxHover[data-v-c06d6d56]:hover {\r\n  opacity: 0.6;\n}\r\n", ""]);
// Exports
module.exports = exports;
